import(/* webpackMode: "eager" */ "/vercel/path0/pkg-onboarding/user-webapp/src/app/error.tsx");
